import { newAPI } from '../../../services';

export const fetchEmployees = async url => {
  const response = await newAPI.get(url);
  return response.data;
}

export const fetchEmployeeRegister = async (userId, registerId) => {
  const response = await newAPI.get(`${userId}/users/${registerId}`);
  return response.data;
}

export const fetchEmployeeByEmail = async (userId, email) => {
  const response = await newAPI.get(`${userId}/users/search?email=${email}`);
  return response.data;
}